import { AxiosInstance } from 'axios'
import { SeoBlock, SeoMeta } from '@/shared/api/strapi/requests/types'

export type GetSeoArgs = {
  locale: string
}

export const getSeo = async (client: AxiosInstance, { locale }: GetSeoArgs): Promise<SeoBlock | undefined> => {
  const path = `/about-page-block`
  const params = {
    locale,
    fields: ['id'],
    populate: {
      seo: {
        populate: '*',
      },
    },
  }

  return (await client.get<{ data?: { attributes?: { seo: SeoMeta } } }>(path, { params })).data.data?.attributes
    ?.seo[0]
}
